import * as React from "react";
import { forwardRef } from "react";
const SvgTopRightArrowIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "-1 -1 9 9", style: {
  enableBackground: "new -1 -1 9 9"
}, xmlSpace: "preserve", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("polygon", { points: "0.8,-1 0.8,1 4.2,1 -1,6.3 0.4,7.7 5.8,2.2 5.8,6 7.8,6 7.8,-1 " }));
const ForwardRef = forwardRef(SvgTopRightArrowIcon);
export { ForwardRef as ReactComponent };
